import { createTransport } from "./transportFactory.js";

const { transport } = createTransport("chat");

export const chatTransport = transport;
